export const PRODUCT_ALERT_MODAL_ID = 'product-alert-modal';
export const PRODUCT_CONTEXT_ID = 'product-page';
